import React from 'react';
import './header.css';

export default function Header() {
    return (
        <div className="header">
            <h1>FIND <span style={{ color: "rgb(240, 200, 0)" }}>THE BEST</span> PLACE</h1>
            <h2>FOR YOUR VACATION</h2>
        </div>
    )
}